import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => {
  return {
    headerBox: {
      position: 'relative',
      minHeight: '40px',
    },
    actions: {
      position: 'absolute',
      right: 0,
      top: 0,
      '@media(max-width: 900px)': {
        position: 'static',
        margin: '8px 0',
      },
    },
    editOrganizationWrapper: {
      display: 'grid',
      width: '100%',
      gridTemplateColumns: '292px 1fr',
    },
    menuLinks: {
      padding: '0 16px',
    },
    menu: {
      padding: '26px 0',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      borderRight: '1px solid #E5E7EB',
    },
    menuHeader: {
      padding: '0 16px 16px',
      borderBottom: '1px solid #E5E7EB',
    },
    menuHeaderActions: {
      display: 'flex',
      gap: '8px',
      marginBottom: '16px',
    },
    menuLinksList: {
      listStyle: 'none',
    },
    w100: {
      width: '100%',
    },
  }
})
